/**
 * FR-ACC-03, FR-PRIV-01: turns what an admin types ("uat.brisktag.com", "http://localhost:5174/")
 * into an origin ("https://uat.brisktag.com"). Returns undefined when it is not a usable origin.
 */
export function normalizeOrigin(input: string): string | undefined {
  const trimmed = input.trim();
  if (!trimmed) return undefined;
  const withScheme = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const url = new URL(withScheme);
    if (url.protocol !== "https:" && url.protocol !== "http:") return undefined;
    if (url.username || url.password || url.pathname.length > 1 || url.search || url.hash) {
      return undefined;
    }
    return url.origin;
  } catch {
    return undefined;
  }
}
